import { RpcError } from "grpc-web";
import {
  AddShareAnalyticsEventRequest,
  AddShareAnalyticsEventResponse,
  GetShareAccessTokenRequest,
  GetSharesRequest,
  GetSharesResponse,
  PostShareImpressionRequest,
  PostShareImpressionResponse,
  Share,
  ShareAnalytics,
} from "../proto/api_pb";
import { PostShareRequest, PostShareResponse } from "../proto/api_pb";
import { GetShareAccessTokenResponse } from "../proto/api_pb";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { backOff } from "exponential-backoff";
import * as Sentry from "@sentry/react";

export const getShareUrl = async (
  token: string,
  userId: string,
  share: Share,
  enterpriseId?: string
): Promise<RpcError | PostShareResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new PostShareRequest();
    request.setUserId(userId);
    request.setShare(share);
    if (enterpriseId) request.setEnterpriseId(enterpriseId)
    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<PostShareResponse | RpcError>((resolve, reject) => {
          ommuseClient.postShare(request, metadata, function (err, response) {
            if (err) {
              reject(err);
            } else {
              resolve(response);
            }
          });
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
        Sentry.captureException(e);
return undefined;
  }
};

export const getShareAccessToken = async (
  id: string,
  password?: string
): Promise<RpcError | GetShareAccessTokenResponse | undefined> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new GetShareAccessTokenRequest();
  request.setId(id);
  if (password) {
    request.setPassword(password);
  }
  const metadata = {
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<GetShareAccessTokenResponse | RpcError>(
        (resolve, reject) => {
          ommuseClient.getShareAccessToken(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }
      ),
    {
      numOfAttempts: 3,
      jitter: "full",
      retry: (e: any) => {
        const msg = e?.message || "";
        if (msg.includes("password required") || msg.includes("incorrect password")) return false;
        return true;
      },
    }
  );
};

export const increaseShareUrlViews = async (
  shareId: string,
  token: string
): Promise<RpcError | PostShareImpressionResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new PostShareImpressionRequest();
    request.setId(shareId);
    const metadata = {
      "Access-Control-Allow-Origin": "*",
      Authorization: `${token}`,
    };
    return await backOff(
      () =>
        new Promise<PostShareImpressionResponse | RpcError>(
          (resolve, reject) => {
            ommuseClient.postShareImpression(
              request,
              metadata,
              function (err, response) {
                if (err) {
                  reject(err);
                } else {
                  resolve(response);
                }
              }
            );
          }
        ),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
        Sentry.captureException(e);
return undefined;
  }
};

export const getAllShares = async (
  userId: string,
  token: string,
  enterpriseId?: string
): Promise<RpcError | GetSharesResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetSharesRequest();
    request.setUserId(userId);
    if (enterpriseId) {
      request.setEnterpriseId(enterpriseId)
    }
    const metadata = {
      "Access-Control-Allow-Origin": "*",
      Authorization: `${token}`,
    };
    return await backOff(
      () =>
        new Promise<GetSharesResponse | RpcError>((resolve, reject) => {
          ommuseClient.getShares(request, metadata, function (err, response) {
            if (err) {
              reject(err);
            } else {
              resolve(response);
            }
          });
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
        Sentry.captureException(e);
return undefined;
  }
};

export const AddShareAnalyticsEvent = async (
  token: string,
  shareAnalytics: ShareAnalytics
): Promise<RpcError | AddShareAnalyticsEventResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new AddShareAnalyticsEventRequest();
    request.setShareAnalytics(shareAnalytics);
    const metadata = {
      "Access-Control-Allow-Origin": "*",
      Authorization: `${token}`,
    };
    return await backOff(
      () =>
        new Promise<AddShareAnalyticsEventResponse | RpcError>((resolve, reject) => {
          ommuseClient.addShareAnalyticsEvent(request, metadata, function (err, response) {
            if (err) {
              reject(err);
            } else {
              resolve(response);
            }
          });
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
        Sentry.captureException(e);
return undefined;
  }
};
